import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Building2, MapPin, Calendar } from 'lucide-react';

const ExperienceSection = () => {
  const sectionRef = useScrollReveal();

  const experiences = [
    {
      institution: 'GMC Gadchiroli',
      role: 'Senior Resident',
      location: 'Gadchiroli, Maharashtra',
      period: '2026 - 2027',
      description: 'Providing advanced medical care as a senior resident, managing complex clinical cases and mentoring junior staff in a government healthcare setting.'
    },
    {
      institution: 'NKP Salve Institute of Medical Sciences',
      role: 'MD Resident - General Medicine',
      location: 'Nagpur, Maharashtra',
      period: '2022 - 2025',
      description: 'Comprehensive training in general medicine with focus on critical care, emergency management, and advanced clinical procedures.'
    },
    {
      institution: 'AIIMS Nagpur',
      role: 'Duty Medical Officer (COVID-19 Pandemic)',
      location: 'Nagpur, Maharashtra',
      period: '2020 - 2021',
      description: 'Served on the frontlines during COVID-19 pandemic, managing critical patients, emergency response, and providing essential healthcare services during the crisis.'
    }
  ];

  return (
    <section id="experience" className="py-20 px-4 bg-slate-50" ref={sectionRef}>
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 text-center scroll-reveal">
          Clinical Experience
        </h2>
        <div className="w-20 h-1 mx-auto mb-12 scroll-reveal" style={{ backgroundColor: 'var(--medical-primary)', animationDelay: '0.1s' }}></div>

        <div className="space-y-6">
          {experiences.map((exp) => (
            <Card 
              key={exp.institution}
              className="card-hover scroll-reveal-scale transition-all duration-500" 
              style={{ 
                borderLeft: '4px solid var(--medical-primary)',
                animationDelay: `${0.2 + experiences.indexOf(exp) * 0.15}s`
              }}
            >
              <CardHeader>
                <CardTitle className="text-2xl text-slate-900 mb-2">
                  {exp.institution}
                </CardTitle>
                <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6 text-slate-600">
                  <div className="flex items-center gap-2">
                    <Building2 size={18} style={{ color: 'var(--medical-primary)' }} />
                    <span className="font-medium">{exp.role}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <MapPin size={18} style={{ color: 'var(--medical-primary)' }} />
                    <span>{exp.location}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Calendar size={18} style={{ color: 'var(--medical-primary)' }} />
                    <span>{exp.period}</span>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-slate-700 leading-relaxed">{exp.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
